import {
  ConversationFragment,
  ExternalMessageFragment,
} from '@shared/generated/graphql';
import {
  Conversation,
  ConversationWithExternalMessages,
} from '@shared/types/conversation';
import { conversationAnalysisFromFragment } from './conversationAnalysis';
import { conversationEventFromFragment } from './conversationEvent';
import { conversationRatingFromFragment } from './conversationRating';
import { basicUserFromFragment } from './user';

type ExternalMessagePreviewFragment = Pick<
  ExternalMessageFragment,
  'createdAt' | 'externalIdentifier' | 'id' | 'userId'
>;

export function conversationFromFragment(
  fragment: ConversationFragment
): Conversation {
  return {
    id: fragment.id,
    title: fragment.title ?? undefined,
    externalIdentifier: fragment.externalIdentifier,
    createdAt: new Date(fragment.createdAt),
    type: fragment.type,
    status: fragment.status,
    user: basicUserFromFragment(fragment.user),
    summary: fragment.summary ?? undefined,
    metadata: fragment.metadata ?? undefined,
    mediaUrl: fragment.mediaUrl ?? undefined,
    organizationId: fragment.organizationId,
    ratings:
      fragment.ratings?.map((rating) =>
        conversationRatingFromFragment(rating)
      ) ?? [],
    analyses:
      fragment.analyses?.map((analysis) =>
        conversationAnalysisFromFragment(analysis)
      ) ?? [],
    events:
      fragment.events?.map((event) => conversationEventFromFragment(event)) ??
      [],
  };
}

export function conversationWithExternalMessagesFromFragment(
  fragment: ConversationFragment & {
    externalMessages: ExternalMessagePreviewFragment[];
  }
): ConversationWithExternalMessages {
  return {
    id: fragment.id,
    organizationId: fragment.organizationId,
    title: fragment.title ?? undefined,
    externalIdentifier: fragment.externalIdentifier,
    createdAt: new Date(fragment.createdAt),
    type: fragment.type,
    status: fragment.status,
    user: basicUserFromFragment(fragment.user),
    summary: fragment.summary ?? undefined,
    metadata: fragment.metadata ?? undefined,
    mediaUrl: fragment.mediaUrl ?? undefined,
    ratings:
      fragment.ratings?.map((rating) =>
        conversationRatingFromFragment(rating)
      ) ?? [],
    externalMessages:
      fragment.externalMessages?.map((message) => ({
        id: message.id,
        createdAt: new Date(message.createdAt),
        externalIdentifier: message.externalIdentifier,
        userId: message.userId,
      })) ?? [],
    events:
      fragment.events?.map((event) => conversationEventFromFragment(event)) ??
      [],
  };
}
